import { getRequest } from '.'

export type SupportContent = {
  faqEntries: wowaudit.SupportFaqEntry[]
  articlesBySection: Record<string, wowaudit.SupportArticle[]>
}

export const getSupportContent = async (): Promise<SupportContent> => {
  return await getRequest('/api/support/content')
}

export const getSupportArticles = async (
  section: string,
): Promise<wowaudit.SupportArticle[]> => {
  return await getRequest(`/api/support/articles?section=${section}`)
}

export const getSupportArticle = async (
  section: string,
  slug: string,
): Promise<wowaudit.SupportArticle> => {
  return await getRequest(`/api/support/articles/${slug}?section=${section}`)
}
